import { useI18n } from "@/i18n/I18nProvider";

const IMAGES = [
    "https://customer-assets.emergentagent.com/job_match-metrics-35/artifacts/mulp0lrj_image.png",
    "https://customer-assets.emergentagent.com/job_match-metrics-35/artifacts/r07e0c8m_boon%20pic.png",
];
const INITIALS = ["FD", "BC"];

export default function Team() {
    const { t } = useI18n();
    const tm = t.team;
    return (
        <section
            id="team"
            data-testid="team-section"
            className="relative py-24 md:py-32 border-t border-white/5"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-8 mb-14 reveal">
                    <div className="lg:col-span-7">
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#D4FF00] mb-4">
                            {tm.tag}
                        </div>
                        <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter heading-clamp">
                            {tm.headline}{" "}
                            <span className="text-[#D4FF00]">{tm.headlineAccent}</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 self-end">
                        <p className="text-white/65 text-lg leading-relaxed">{tm.sub}</p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-5 md:gap-6">
                    {tm.members.map((p, i) => (
                        <div
                            key={p.name}
                            data-testid={`team-card-${i}`}
                            className="card-hover rounded-2xl border border-white/10 bg-[#071B12] overflow-hidden reveal group"
                        >
                            <div className="aspect-[16/10] relative overflow-hidden bg-[#0E2B1E]">
                                <img
                                    src={IMAGES[i]}
                                    alt={p.name}
                                    className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-100 group-hover:scale-105"
                                    onError={(e) => {
                                        e.currentTarget.style.display = "none";
                                    }}
                                />
                                <div
                                    className="absolute inset-0 bg-gradient-to-t from-[#071B12] via-transparent to-transparent pointer-events-none"
                                    aria-hidden
                                />
                                <div className="absolute top-4 left-4 h-14 w-14 rounded-full bg-[#D4FF00] text-[#04140D] grid place-items-center font-display font-bold text-lg lime-glow">
                                    {INITIALS[i]}
                                </div>
                                <div className="absolute bottom-4 right-4 text-[10px] uppercase tracking-widest text-[#D4FF00] font-bold bg-[#04140D]/70 backdrop-blur-md px-2.5 py-1 rounded">
                                    {p.role}
                                </div>
                            </div>
                            <div className="p-7">
                                <div className="font-display font-bold uppercase text-2xl md:text-3xl tracking-tight">
                                    {p.name}
                                </div>
                                <div className="mt-1 text-sm text-[#D4FF00] font-semibold uppercase tracking-wider">
                                    {p.sub}
                                </div>
                                <p className="mt-4 text-[15px] text-white/70 leading-relaxed">
                                    {p.bio}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
